/** Names are nullable - some SSO providers never send the `given_name` /
 * `family_name` claims, so never interpolate them directly ("null null").
 * Returns "" when unknown; callers fall back to the email. */
export const userFullName = (user?: {
  first_name?: string | null;
  last_name?: string | null;
}) => [user?.first_name, user?.last_name].filter(Boolean).join(" ");
